import { type RichTranslationValues } from 'next-intl'

export const htmlFormats: RichTranslationValues = {
  // eslint-disable-next-line id-length
  b: (text) => <b>{text}</b>,
  br: () => <br />,
  span: (text) => <span>{text}</span>,
}
